import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useReveal from "./hooks/useReveal";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LimeShowcase from "./components/LimeShowcase";
import Stats from "./components/Stats";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Process from "./components/Process";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import CtaBanner from "./components/CtaBanner";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => {
  useReveal();
  return (
    <div className="App" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <LimeShowcase />
        <Stats />
        <Services />
        <Portfolio />
        <Process />
        <Pricing />
        <Testimonials />
        <CtaBanner />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
